import React from "react";
import Module from "../components/Module";
import "./ContextSection.css";
import thereContext from "../assets/images/there-context.png";
import useDevice from "../hooks/useDevice";

const modulesData = [
  {
    icon: "worldmap",
    title: "Contexte",
    body: "Tournage à Los Angeles dans une grande école de cinéma (top#5 US) LMU, School of Film and TV",
  },
  {
    icon: "camera",
    title: "Équipement",
    body: "Images tournées avec Arri Alexa \nDécors construits en studio\nStation de montage dispo sur Paris",
  },
  {
    icon: "calendar",
    title: "Calendrier",
    body: "T4 2025 montage image\nT1 2026 montage son",
  },
];

const ContextSection = () => {
  const { isDesktop } = useDevice();
  return (
    <section className="context">
      <div className="context__modules">
        {modulesData.map((m, i) => (
          <Module key={i} icon={m.icon} title={m.title} body={m.body} />
        ))}
      </div>
      {isDesktop && (
        <img
          src={thereContext}
          alt="Context"
          className="context__image"
          width={280}
          height={280}
        />
      )}
    </section>
  );
};

export default ContextSection;
